import { Link } from '@mui/material'
import { theme } from 'config'
import React from 'react'
import CookieConsent from 'react-cookie-consent'
import { Trans, useTranslation } from 'react-i18next'

export const CookieBanner = (): JSX.Element => {
  const { t } = useTranslation();

  if (sessionStorage.getItem('_cookie_accepted') == '1') return null;

  return (
    <CookieConsent
      enableDeclineButton
      acceptOnScroll
      flipButtons
      setDeclineCookie         = {false}
      onAccept                 = {() => sessionStorage.setItem('_cookie_accepted', '1')}
      debug                    = {true}
      declineButtonStyle       = {declineButtonStyles}
      buttonStyle              = {acceptButtonStyles}
      acceptOnScrollPercentage = {80}
      declineButtonText        = {t('inactivate_cookies')}
      buttonText               = {t('accept_cookies')}
      onDecline                = {() => sessionStorage.setItem('_cookie_inactive', '1')}
      style                    = {{
        backgroundColor: 'rgba(60, 60, 60, 0.6)',
        zIndex:          1300,
        fontSize:        theme.typography.fontSize
      }}
    >
      <Trans
        t          = {t}
        i18nKey    = 'cookie_consent'
        components = {[
          <Link
            underline  = 'hover'
            color      = 'inherit'
            fontWeight = {theme.typography.fontWeightBold}
            sx         = {{ textDecoration: 'none' }}
            href       = 'https://www.blendow.se/om/integritetsskyddspolicy/'
          />
        ]}
      />
    </CookieConsent>
  );
};

const acceptButtonStyles = {
  background:    'white',
  fontSize:      '1.2rem',
  padding:       '1.2rem 3rem',
  lineHeight:    1.75,
  boxShadow:     'none',
  textTransform: 'uppercase',
  fontFamily:    'inherit',
  fontWeight:    600,
  borderRadius:  '4rem',
  color:         'black',
  letterSpacing: '.1rem',
};

const declineButtonStyles = {
  background:    'none',
  fontSize:      '1.2rem',
  outline:       '1px solid white',
  padding:       '1.2rem 3rem',
  lineHeight:    1.75,
  boxShadow:     'none',
  textTransform: 'uppercase',
  fontFamily:    'inherit',
  fontWeight:    600,
  borderRadius:  '4rem',
  color:         'white',
  letterSpacing: '.1rem',
};